// define App contexts
import { createContext } from 'react'

export const AppContext = createContext({
  isWrongNetwork: false,
})
